import { useCallback, useEffect, useState } from 'react';
import { Box, ButtonBase, InputBase, makeStyles } from '@material-ui/core';
import { AutoCompleteSelect } from '../../../../components';
import Dialog from '../../../../components/Dialog';
import { NEW_BED_STATUS_CUBICLE_ITEM_LIST } from '../../../../comm/constant';
import LongRemark from '../../../../components/LongRemark';
import EmptyBed from '../Icons/EmptyBed';
import { Checkbox } from '../../../DutyAssign/components/Attendance/Setting';
import { generateGrid } from '../../../../utils/newBedStatusUtil';
import StyleButton from '../../../../components/StyleButton';

const useStyles = makeStyles(() => ({
  title: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: '#666666',
  },
  star: {
    color: '#ff0000',
  },
  input: {
    width: '100%',
    height: '3.5rem',
    padding: '1.25rem',
    border: 'solid 1px #e4e7eb',
    borderRadius: '10px',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
  },
  deletePopupContent: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.25rem',
    color: '#2e4469',
  },
  bedArrangement: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1rem',
    color: '#538fff',
  },
  content: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
  },
}));

const EditNurseStation = ({
  edit,
  data,
  handleClose,
  handleUpdateNurseStation,
  handleDeleteCubicle,
  setPopup,
  handleCopyCubicle,
}) => {
  const classes = useStyles();
  const [form, setForm] = useState({
    name: data.name ?? '',
    color: data.color ?? '',
    bedArrangement: data.bedArrangement ?? '',
    borderLine: data.borderLine,
  });
  const [deletePopup, setDeletePopup] = useState(false);

  useEffect(() => {
    if (!edit) {
      setPopup(true);

      return () => setPopup(false);
    }
  }, [edit]);

  const handleForm = useCallback(
    (type) => (e) => {
      if (type === 'color') {
        setForm((o) => ({ ...o, [type]: e }));
      } else {
        setForm((o) => ({ ...o, [type]: e.target.value }));
      }
    },
    []
  );

  const handleSubmit = useCallback(() => {
    if (edit) {
      handleUpdateNurseStation({
        id: data.id,
        data: {
          ...form,
          beds: generateGrid(form.bedArrangement.row, form.bedArrangement.column),
        },
      });
      handleClose();
    } else {
      handleUpdateNurseStation(data, form, handleClose);
    }
  }, [handleUpdateNurseStation, data, form, handleClose, edit]);

  const handleCancel = useCallback(() => {
    if (edit) {
      setDeletePopup(true);
    } else {
      handleClose();
    }
  }, [handleDeleteCubicle, data, edit, handleClose]);

  const handleDeletePopupOpen = useCallback(
    (open) => () => {
      setDeletePopup(open);
    },
    []
  );

  // 选择床位
  const handleBedArrangement = useCallback(
    ({ column, row }) =>
      () => {
        setForm((o) => {
          let maxRow = 0;
          let maxColumn = 0;

          data.beds.forEach((item) => {
            if (item.data && item.row > maxRow) {
              maxRow = item.row;
            }
            if (item.data && item.column > maxColumn) {
              maxColumn = item.column;
            }
          });

          if (column + 1 < maxColumn || row + 1 < maxRow) {
            return o;
          } else {
            o.bedArrangement = { column: column + 1, row: row + 1 };
            return { ...o };
          }
        });
      },
    [data.beds]
  );

  // 判断床位是否选择上
  const handleSelected = useCallback(
    ({ column, row }) => {
      return Boolean(form.bedArrangement.column >= column + 1 && form.bedArrangement.row >= row + 1);
    },
    [form.bedArrangement]
  );

  // 选择是否显示border
  const handleSelectBorderLine = useCallback(() => {
    setForm((o) => ({
      ...o,
      borderLine: o.borderLine === 'show' ? 'hide' : 'show',
    }));
  }, []);

  // 处理 copy cubicle
  const copy = useCallback(() => {
    handleCopyCubicle({
      data: {
        ...data,
        ...form,
        beds: generateGrid(form.bedArrangement.row, form.bedArrangement.column),
        name: `${form.name}(copy)`,
      },
    });
    handleClose();
  }, [handleCopyCubicle]);

  return (
    <>
      <Dialog open={true} width={edit ? '69rem' : '43.75rem'} title="Edit" handleClose={handleClose} haveFoot={false}>
        <Box display="flex" gridGap="2.5rem">
          <Box display="flex" gridGap="1.25rem" flexBasis="100%">
            <Box display="flex" flexDirection="column" gridGap="0.75rem" flexBasis="50%">
              <div className={classes.title}>
                Name<span className={classes.star}>*</span>
              </div>
              <InputBase className={classes.input} value={form.name} onChange={handleForm('name')} />
            </Box>
            <Box display="flex" flexDirection="column" gridGap="0.75rem" flexBasis="50%">
              <div className={classes.title}>Colour</div>
              <AutoCompleteSelect
                type="color"
                width="100%"
                itemList={NEW_BED_STATUS_CUBICLE_ITEM_LIST.CubicleColor}
                value={form.color}
                onChange={handleForm('color')}
                colorIconBorder="solid 1px #e4e7eb"
              />
              <Box display="flex" alignItems="center" gridGap="0.75rem">
                <Checkbox check={form.borderLine === 'show'} handleChange={handleSelectBorderLine} />
                <div className={classes.content}>Show border line</div>
              </Box>
            </Box>
          </Box>
          {edit && <Box width="0.063rem" bgcolor="#e4e7eb" height="34.813rem" />}
          {edit && (
            <Box display="flex" flexDirection="column" gridGap="1rem" flexBasis="100%">
              <Box display="flex">
                <div className={classes.title}>Size</div>
                <LongRemark content="123" />
              </Box>
              <Box
                display="flex"
                flexDirection="column"
                padding="0.625rem 1rem 1.313rem"
                bgcolor="#f1f5fb"
                borderRadius="8px"
                gridGap="0.75rem"
              >
                <div
                  className={classes.bedArrangement}
                >{`${form.bedArrangement.column}x${form.bedArrangement.row}`}</div>
                <Box
                  display="grid"
                  gridGap="0.45rem"
                  gridTemplateColumns="1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr"
                >
                  {bedArray.map((item) => (
                    <ButtonBase onClick={handleBedArrangement(item)} key={JSON.stringify(item)}>
                      <EmptyBed selected={handleSelected(item)} popup />
                    </ButtonBase>
                  ))}
                </Box>
              </Box>
            </Box>
          )}
        </Box>
        {/* Footer */}
        <Box display="flex" justifyContent="center" mt="3.25rem" gridGap="1.25rem">
          {edit && <StyleButton onClick={copy} text="Copy" type="fill" width="12.5rem" backgroundColor="#28d2ab" />}
          <StyleButton
            onClick={handleCancel}
            text={edit ? 'Delete' : 'Cancel'}
            type="fill"
            width="12.5rem"
            backgroundColor={edit ? '#ff655c' : '#eff6ff'}
            color={edit ? '#fff' : '#538fff'}
          />
          <StyleButton onClick={handleSubmit} text="Update" type="fill" width="12.5rem" backgroundColor="#28d2ab" />
        </Box>
      </Dialog>

      {/* delete popup */}
      {deletePopup && (
        <Dialog
          open={deletePopup}
          title="Remove Cubicle"
          cancel="Cancel"
          confirm="Remove"
          handleCancel={handleDeletePopupOpen(false)}
          handleClose={handleDeletePopupOpen(false)}
          handleConfirm={handleDeleteCubicle(data.id)}
          cancelStyle={{ border: 'unset' }}
          confirmStyle={{ color: '#fff', backgroundColor: '#ff655c' }}
        >
          <div className={classes.deletePopupContent}>Are you sure to remove the cubicle?</div>
        </Dialog>
      )}
    </>
  );
};

const rows = 12;
const cols = 14;

const bedArray = Array.from({ length: rows * cols }, (_, index) => ({
  column: index % cols,
  row: Math.floor(index / cols),
}));

export default EditNurseStation;
